import React from 'react'
import { AgentRegistrationStatus } from '@/components/composed/financing/AgentRegistrationStatus'
import { messages } from './messages'
import type { IPublicationFinancingWidgetCollapsingAgentRegistrationErrorProps } from './types'

export const PublicationFinancingWidgetCollapsingAgentRegistrationError: React.FC<
  IPublicationFinancingWidgetCollapsingAgentRegistrationErrorProps
> = props => {
  const { onClose } = props

  return (
    <AgentRegistrationStatus
      icon="red/info"
      title={messages.title}
      subtitle={messages.subtitle}
      actionText={messages.actions.close}
      onAction={onClose}
    />
  )
}
